export default {
    aggregationType: 'NONE',
    valueType: 'TEXT',
};



/** WEBPACK FOOTER **
 ** ./src/model/config/model-defaults/dataElement.js
 **/